import React from "react";
import { useProductCardContext } from "./product-card";
// eslint-disable-next-line css-modules/no-unused-class
import styles from "./product-card-image.css";
import ProductCardLinkCuratedAd from "./product-card-link-curated-ad";

// Curated Ads products lack the features and analytics that most product cards have.
type ProductCardImageCuratedAdProps = Record<string, never>;

export function ProductCardImageCuratedAd({}: ProductCardImageCuratedAdProps): React.ReactElement {
    const width = 125;
    const height = 156;
    const { image_url: imageURL, image_alt_text: imageAltText } = useProductCardContext();

    if (!imageURL) {
        return (
            <div style={{ position: "relative", width, height }}>
                <ProductCardLinkCuratedAd className={styles.imageLink} reason="image" />
            </div>
        );
    }

    return (
        <div className={styles.imageWrapper}>
            <ProductCardLinkCuratedAd reason="image">
                <img
                    className={styles.image}
                    width={width}
                    height={height}
                    src={imageURL}
                    alt={imageAltText}
                    data-pin-no-hover="true"
                />
            </ProductCardLinkCuratedAd>
        </div>
    );
}

export default ProductCardImageCuratedAd;
